import { Column } from 'primereact/column';
import { useEffect, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { MonitoreoService } from '../../service/monitoreo/MonitoreoService';
import { Dropdown } from 'primereact/dropdown';

export const ConfCatalogo = ({ archivo, toast, permss, generic, opcion }) => {

    const [totalRecords, setTotalRecords] = useState(0);
    const [loading, setLoading] = useState(false);
    const [registers, setRegisters] = useState(null);
    const conSrv = new MonitoreoService();
    const [catalogo, setCatalogo] = useState(null);
    const [tipo, setTipo] = useState(null);
    const [lazyParams, setLazyParams] = useState(generic.paramLazy({ nombre: 'contains' }, null));

    useEffect(() => {
        listado();
    }, []);

    useEffect(() => {
        if (catalogo?.padre) {
            loadLazyData();
        }
    }, [lazyParams]);

    const listado = () => {
        conSrv.consultar(archivo?.tipo, "ficha/config-archivo/catalogo").then(res => {
            setCatalogo(res.data);
        });
    }

    const onPage = (event) => {
        event.filters = lazyParams.filters;
        setLazyParams(event);
    }

    const onSort = (event) => {
        event.filters = lazyParams.filters;
        setLazyParams(event);
    }

    const onFilter = (event) => {
        event['first'] = 0;
        setLazyParams(event);
    }

    const loadLazyData = (idp = null) => {
        setLoading(true);

        let _lazyParams = lazyParams;
        _lazyParams.idc = archivo?.id;
        _lazyParams.idp = idp ?? tipo?.cat_id;
        setLoading(true);
        conSrv.listado("ficha/config-archivo/lista-catalogo", { lazyEvent: JSON.stringify(_lazyParams) }).then(res => {
            setTotalRecords(res.data.total);
            setRegisters(res.data.registros);
        }).finally(() => {
            setLoading(false);
        });
    }

    const onChange = (e, rowData) => {
        if (rowData.obligatorio === e.value?.cat_id) return;

        const data = {
            id: rowData.id,
            con: archivo?.id,
            obligatorio: e.value?.cat_id,
            tipo: opcion
        };
        setLoading(true);
        conSrv.editar(data, 'ficha/config-archivo/catalogo-asignar').then(res => {
            generic.funcSuccess(res, toast);
            const regs = registers.map(info => {
                if (info.id === rowData.id) {
                    const data = { ...info, etiqueta: e.value?.nombre, obligatorio: e.value?.cat_id };
                    return data;
                }
                return info;
            });
            setRegisters(regs);
        }).catch(error => {
            toast.current.show({ severity: 'error', summary: 'Error', detail: error.message, life: 3000 });
        }).finally(() => {
            setLoading(false);
        });
    }

    const consultar = (value) => {
        setTipo(value);
        loadLazyData(value?.cat_id);
    }

    const obligatorioEditor = (options) => {
        const value = { cat_id: options.rowData?.obligatorio, nombre: options.rowData?.etiqueta };
        return (
            <Dropdown
                value={value}
                options={generic.sinonull}
                optionLabel="nombre"
                onChange={(e) => onChange(e, options.rowData)}
                placeholder="Seleccione"
                style={{ width: '100%' }}
                filter
                filterBy="nombre"
            />
        );
    };

    return (
        <>
            {catalogo?.padre &&
                <div className="formgrid grid align-items-center justify-content-center">
                    <div className="field col-6 p-1">
                        <b>Catálogo</b>
                        <Dropdown options={catalogo?.padre} value={tipo} onChange={(e) => consultar(e.value)}
                            optionLabel="nombre" placeholder="Seleccione una área" />
                    </div>
                </div>
            }
            {catalogo?.padre && registers &&
                <DataTable value={registers} lazy className="datatable-responsive" filterDisplay="row" dataKey="id" paginator first={lazyParams.first} rows={10} totalRecords={totalRecords}
                    onPage={onPage} onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder} onFilter={onFilter} filters={lazyParams.filters} loading={loading}
                    editMode="cell">
                    <Column field="nombre" header='Items' sortable showFilterMenu={false} filterField='nombre' filter filterPlaceholder='Filtrar por nombre' />
                    <Column field="etiqueta" header="Obligatorio" editor={(options) => obligatorioEditor(options)} style={{ width: '20%' }}></Column>
                    <Column field="fecha" header="Fecha cambio" style={{ width: '15%' }}></Column>
                </DataTable>
            }
        </>
    )
}
